export default "__VITE_ASSET__Ci_wa_La__"